// extracted by mini-css-extract-plugin
export var banner = "_1j-0";
export var icon = "_1j-1";
export var message = "_1j-2";